var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._v(" \"三秦好少年・红飘带 少年心\"主题征文活动作品上传平台 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }